export enum EPayoutModeType {
	UPI = 'UPI',
	BANK = 'BANK'
}

export enum EFeatureType {
	PAYOUT = 'payout',
	CHECKOUT = 'checkout'
}

export enum PaymentGateway {
	RAZORPAY = 'razorpay',
	CASHFREE = 'cashfree',
	PAYTM = 'paytm',
	JUSPAY = 'juspay',
	MOBIKWIK = 'mobikwik',
	PHONEPE = 'phonepe',
	PAYU = 'payu',
	RAZORPAY_V2 = 'razorpay_v2',
	CASHFREE_ESCROW = 'cashfree_escrow',
	CASHFREE_V2 = 'cashfree_v2',
	CASHFREE_V3 = 'cashfree_v3'
}

export const DEFAULT_OPTIONS = [{ id: 'none', label: 'NONE' }];

export const FEATURE_TYPE_OPTIONS = [
	{ id: EFeatureType.PAYOUT, label: 'PAYOUT' },
	{ id: EFeatureType.CHECKOUT, label: 'CHECKOUT' }
];

export const PAYMENT_GATEWAY_NAME_OPTIONS = [
	{ id: PaymentGateway.RAZORPAY, label: 'RAZORPAY' },
	{ id: PaymentGateway.CASHFREE, label: 'CASHFREE' },
	{ id: PaymentGateway.JUSPAY, label: 'JUSPAY' },
	{ id: PaymentGateway.PHONEPE, label: 'PHONEPE' },
	{ id: PaymentGateway.PAYU, label: 'PAYU' },
	{ id: PaymentGateway.RAZORPAY_V2, label: 'RAZORPAY V2' },
	{ id: PaymentGateway.CASHFREE_V2, label: 'CASHFREE V2' },
	{ id: PaymentGateway.CASHFREE_V3, label: 'CASHFREE V3' }
];

export type SDFilters = {
	notificationType: string;
	isActive: boolean;
	merchantName: string;
};

export interface IPaymentNotificationTemplate {
	_id?: string;
	createdAt: number;
	updatedAt?: number;
	pgText?: string;
	userText: string;
	title: string;
	isActive?: boolean;
	merchantName?: string;
	category?: string;
	notificationType?: string;
	smsMessage?: string;
	extra: INotificationExtras;
	userFailureMessage?: string;
	delink?: boolean;
	isPGError?: boolean;
	instantFailure?: boolean;
}

export interface INotificationExtras {
	delink?: boolean;
	isPGError?: boolean;
	instantFailure?: boolean;
}

export type ContentPropsT = {
	handleFilterSubmit: (submittedFilters: SDFilters) => void;
	onClose: () => void;
};

export const defaultSDFilter = {
	notificationType: 'payout',
	isActive: true,
	merchantName: 'razorpay'
};

export const defaultSDCreate = {
	startTime: Date.now(),
	endTime: Date.now()
};

export const IS_ACTIVE_OPTIONS = [
	{ id: true, label: 'TRUE' },
	{ id: false, label: 'FALSE' }
];

export const listPageName = '/dashboard/finance/paymentPgFailure/list';
export const editPageName = '/dashboard/finance/paymentPgFailure/edit';
export const updateUri = '/dashboard/updatePaymentPGFailureData/finance-paymentPgFailure-updatePaymentPGFailureData';
export const listAPIUri = '/dashboard/getPaymentPGFailureList/finance-paymentPgFailure-getPaymentPGFailureList';
export const getAllPaymentGatewayListUri = '/dashboard/getAllPaymentGatewayList/finance-paymentPgFailure-getAllPaymentGatewayList';
